export default __webpack_public_path__ + "static/media/H4007.fc11cf56.mp3";